import { observer } from 'mobx-react';
import { useEffect } from 'react';
import RefundLogListRowSkeleton from '../../components/RefundLogListSkeleton/RefundLogListRowSkeleton';
import RefundLogListHeaderSkeleton from '../../components/RefundLogListSkeleton/RefundLogListHeaderSkeleton';
import { RefundLogColumnTitles } from '../../components/RefundLogColumnTitles/RefundLogColumnTitles';
import { emptyArray } from 'src/utils/helpers';
import refundLogStore from '~/view/screens/RefundLogScreen/screens/RefundLog/store/refundLogStore';
import RefundLogListRow from 'src/view/screens/RefundLogScreen/screens/RefundLog/components/RefundLogListRow/RefundLogListRow';
import './style.scss';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import Pagination from '~/view/components/Controls/PaginationOld/PaginationOld';
import { paginationLightToPagination } from '~/helpers';
import NoData from '~/view/screens/MenuManagementScreen/screens/ItemManagementScreen/components/NoData/NoData';

const RefundLogList = observer((): JSX.Element => {
  useEffect(() => {
    refundLogStore.fetch();

    return () => {
      refundLogStore.unMount();
    };
  }, []);

  const { pagination, transactions } = refundLogStore;

  const handleClickPagination = (page: number) => {
    refundLogStore.page = page;
    refundLogStore.setPage(page);
  };

  const RefundLogHeaders = () => {
    if (refundLogStore.loading) {
      return <RefundLogListHeaderSkeleton />;
    }
    if (transactions.length) {
      return <RefundLogColumnTitles />;
    }
    return null;
  };

  const RefundLogList = () => {
    if (refundLogStore.loading) {
      return emptyArray().map((_, index) => <RefundLogListRowSkeleton key={'skeleton-' + String(index)} />);
    }

    return transactions.length ? (
      transactions.map((transaction, index) => <RefundLogListRow key={index} refundLog={transaction} />)
    ) : (
      <NoData message="no_refund_log_found" />
    );
  };

  return (
    <div className="d-flex flex-column flex-1 mt-4">
      <ScrollableBlock
        showScrollbar
        scrollClassName="d-flex flex-column full-height pr-3"
        className="overflow-y-scroll mb-3 refund-log"
        direction="vertical"
      >
        {RefundLogHeaders()}
        {RefundLogList()}
      </ScrollableBlock>

      <Pagination pagination={paginationLightToPagination(pagination, transactions)} className="mt-2" onChange={handleClickPagination} />
    </div>
  );
});

export default RefundLogList;
